export const REGEX_TIERS_NAMES = ['BRONZE', 'SILVER', 'GOLD', 'PLATINUM'];
export const LOYALTY_HEADERS = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
};
export const LOYALTY_DETAILS_LINK = 'https://www.macys.com/customer-service/articles/macys-star-rewards-terms-conditions';
